import React from "react";
import './css/App.css'
import {Routes, Route} from 'react-router-dom'
import TrackingPage from './component/TrackingPage'
import MaintenancePage from './component/MaintenancePage'

import 'bootstrap/dist/css/bootstrap.min.css';
function App() {
    return (
      <>
        <header>
        
        </header>
        <main>
          <Routes>
            <Route path='/consultar/tracking/:trackingNumber' element={<TrackingPage/>}/>
            <Route path='/maintenance' element={<MaintenancePage/>}/>
          </Routes>
        </main>
      </>
    );
  }
export default App;